import React from 'react';
import { useJiraWorkmanagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { type RouteContext, Redirect } from '@atlassian/react-resource-router';

export const ProjectSettingsRedirect = ({ match }: RouteContext) => {
	const { data } = useJiraWorkmanagementProjectNavigation();
	const { projectKey } = match.params;

	if (
		data?.permissionInfo?.isAdmin ||
		data?.permissionInfo?.isSiteAdmin ||
		data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS
	) {
		return <Redirect to={`/jira/core/projects/${String(projectKey)}/settings/details`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/workflows`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/issuelayout`} />;
	}

	return (
		<Redirect to={`/jira/core/projects/${String(match.params.projectKey)}/settings/details`} />
	);
};
